import { render, staticRenderFns } from "./Recrutamento.vue?vue&type=template&id=edc50cd0"
import script from "./Recrutamento.vue?vue&type=script&lang=js"
export * from "./Recrutamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports